module.exports = __webpack_public_path__ + "static/img/23.12a1891.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/23.png
// module id = qCh8
// module chunks = 0